"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLegend = _interopRequireDefault(require("../control-legend"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ControlToggleSet =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ControlToggleSet, _React$Component);

  function ControlToggleSet() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ControlToggleSet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ControlToggleSet)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onChange", function (e) {
      return _this.props.onChange(e.target.value, _this.props.id);
    });

    return _this;
  }

  _createClass(ControlToggleSet, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          id = _this$props.id,
          value = _this$props.value,
          legend = _this$props.legend,
          options = _this$props.options,
          optional = _this$props.optional,
          aside = _this$props.aside,
          autoFocus = _this$props.autoFocus,
          validationError = _this$props.validationError,
          themeToggleGroup = _this$props.themeToggleGroup,
          themeToggleContainer = _this$props.themeToggleContainer,
          themeToggle = _this$props.themeToggle,
          themeControlWrapper = _this$props.themeControlWrapper,
          themeLegend = _this$props.themeLegend;
      var groupProps = {
        id: id,
        className: "toggle-group round-full ".concat(themeToggleGroup),
        role: 'radiogroup',
        'aria-required': optional ? false : true,
        'data-test': "".concat(id, "-input")
      };

      if (validationError) {
        groupProps['aria-invalid'] = true;
      }

      var renderOptions = function renderOptions(d) {
        var extraProps = (0, _omit.default)(d, ['value', 'label']);
        return _react.default.createElement("label", {
          key: d.value,
          className: "toggle-container ".concat(themeToggleContainer)
        }, _react.default.createElement("input", _extends({
          value: d.value,
          checked: d.value === value,
          autoFocus: autoFocus && d.value === value,
          onChange: _this2.onChange,
          name: id,
          type: "radio"
        }, extraProps)), _react.default.createElement("div", {
          className: "".concat(themeToggle, " toggle")
        }, d.label));
      };

      return _react.default.createElement(_controlWrapper.default, {
        themeControlWrapper: themeControlWrapper,
        id: id,
        validationError: validationError
      }, _react.default.createElement("fieldset", null, legend && _react.default.createElement(_controlLegend.default, {
        text: legend,
        id: id,
        aside: aside,
        optional: optional,
        themeLegend: themeLegend
      }), _react.default.createElement("div", groupProps, options.map(renderOptions))));
    }
  }]);

  return ControlToggleSet;
}(_react.default.Component);

exports.default = ControlToggleSet;

_defineProperty(ControlToggleSet, "propTypes", {
  /** Identifying value for input element. */
  id: _propTypes.default.string.isRequired,

  /** Function that's called when text changes in the input element. Argument that's returned the id prop and value entered. */
  onChange: _propTypes.default.func.isRequired,

  /** An array of objects containing `label` `value` key value pairings to represent each option. Any additional keys are passed as props to the input. */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node.isRequired,
    value: _propTypes.default.string.isRequired
  })).isRequired,

  /** Legend name */
  legend: _propTypes.default.string,

  /** input value */
  value: _propTypes.default.string,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the legend element. */
  aside: _propTypes.default.node,

  /** Add auto focus attributes. */
  autoFocus: _propTypes.default.bool,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /** Assembly classes to apply to the toggle group */
  themeToggleGroup: _propTypes.default.string,

  /** Assembly classes to apply to the toggle container */
  themeToggleContainer: _propTypes.default.string,

  /** Assembly classes to apply to the toggle element */
  themeToggle: _propTypes.default.string,

  /** Assembly classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** Assembly classes to apply to the legend element */
  themeLegend: _propTypes.default.string
});

_defineProperty(ControlToggleSet, "defaultProps", {
  value: '',
  optional: false,
  autoFocus: false,
  themeToggleGroup: 'border border--2 border--blue bg-blue',
  themeToggleContainer: '',
  themeToggle: 'txt-s py3 toggle--white toggle--active-blue'
});